export const getHomesteadSeriesPrizeConfig = () => {
  return {
    prizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950989/isreal-dome-image-01_ss9xf1.jpg',
        alt: 'Trip',
        title: 'London and Holy Land Trip',
        value: '$83,780',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-tv-img-01_msjty9.jpg',
        alt: 'TV',
        title: 'LG OLED 83” Class 4K Smart TV',
        value: '$5,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950991/movie-theater-chairs-01_fetvpe.jpg',
        alt: 'Two Flex HR Theater Chairs',
        title: 'Two Flex HR Theater Chairs',
        value: '$2,900',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-speakers-img-01_dmwtgy.jpg',
        alt: 'Sonos Ultimate Immersive',
        title: 'Sonos Ultimate Immersive Sound System',
        value: '$2,696',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-redvines-img-01_jq9ucp.jpg',
        alt: 'Pallet of Redvines Candy',
        title: 'Half Pallet of Red Vines (360 Count)',
        value: '$1,215',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950989/amgel-guild-img-01_fl4i7j.jpg',
        alt: '5-Year Angel Guild Membership (non-transferrable)',
        title: '5-Year Angel Guild Membership (non-transferrable)',
        value: '$1,200',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402043/kok-giveaway-chocolate-img-01_q5ez5f.jpg',
        alt: 'Variety pack of Chocolate',
        title: '36 Variety Packs of Mars Chocolate Full size (30 Pack)',
        value: '$1,008',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-switch-img-01_lfbg2o.jpg',
        alt: 'Nintendo Switch Package',
        title: 'Nintendo Switch Package - Includes Mario Kart 8 Deluxe and Joy-Con Game Controllers',
        value: '$490',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402043/kok-giveaway-fridge-img-01_f8fngp.jpg',
        alt: 'Newair Pismatic Can Beverage Fridge',
        title: 'Newair Prismatic 85 Can Beverage Fridge',
        value: '$500',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950987/beanbag-image-01_pzd8pa.jpg',
        alt: 'Ultimate Sack 5000: Bean Bag Chair',
        title: 'Ultimate Sack 5000: Bean Bag Chair',
        value: '$430',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-popcorn-img-01_pscrge.jpg',
        alt: 'Gold Medal Mega Pop Popcorn',
        title: '6 Gold Medal Mega Popcorn Kits 8 oz. (36 Pack)',
        value: '$256',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950989/popcorn-machine-01_hhddb6.jpg',
        alt: 'Nostalgia Popcorn Maker Machine',
        title: 'Nostalgia Popcorn Maker Machine',
        value: '$240',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739402042/kok-giveaway-appleTV-img-01_ce8eiv.jpg',
        alt: 'Apple TV 4K',
        title: 'Apple TV 4K',
        value: '$150',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1738950989/candy-image-shelf-01_fmmrq0.jpg',
        alt: 'Bachel Rustic Snack Cabinet',
        title: 'Bachel Rustic Brown wood Pantry Cabinet with Pull-Out Snack Stand',
        value: '$130',
      },
    ],
    galleryImages: [
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951554/KOK_Google-Search-Images_1.91x1_V3_n8qoqx.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951554/KOK_Google-Search-Images_1.91x1_V4_bssggs.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V5_bztj2y.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V6_io7abi.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V7_jhpkuw.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V8_enrlcz.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V9_uusowp.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V10_ttuohl.jpg',
        alt: 'King of Kings Images',
      },
    ],
  }
}
